const Resources = {

    table_headers: [
        // {
        //     text:   'S. Scenario',
        //     align:  'start',
        //     value:  'staffing_scenario'
        // },
        {
            text:   'Order',
            align:  'start',
            value:  'order'
        },
        {
            text:   'Group',
            align:  'start',
            value:  'group'
        },
        { 
            text:   'Description',
            value:  'description'
        },
        // {
        //     text:   'Order',
        //     value:  'order'
        // },
        {
            text:   'Frequency per Week',
            value:  'frequency_week'
        },
        {
            text:   'Daily Minutes',
            value:  'daily_minutes_to_show'
        },
        {
            text:   'Annual Minutes',
            value:  'annual_minutes_to_show'
        }

    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Budgeting',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Scenarios',
            href:   '/budgeting-staffing-scenario',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Fixed',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

}

export default Resources;